var _rect, _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackFridayTagSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 170,
    height: 33,
    viewBox: "0 0 170 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 169.08,
    height: 30.074,
    rx: 15.037,
    fill: "black"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_22695_117974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3123 14.4006C27.5194 14.851 28.2581 15.7519 28.2581 17.1031C28.2581 20.238 25.3574 20.8506 22.0423 20.8506H15.4662L17.6823 8.23891H23.898C26.5285 8.23891 28.7445 8.90553 28.7445 11.2837C28.7445 12.8872 27.8437 13.8781 26.3123 14.4006ZM21.1955 13.1755H22.6188C23.6818 13.1755 24.3304 12.9413 24.3304 11.9323C24.3304 11.1936 23.6998 11.0855 22.9431 11.0855H21.5559L21.1955 13.1755ZM20.3668 17.9139H22.0783C23.2314 17.9139 23.916 17.6977 23.916 16.6527C23.916 15.8239 23.2314 15.7519 22.4927 15.7519H20.7451L20.3668 17.9139ZM38.655 20.8506H28.5656L30.7817 8.23891H35.2318L33.6463 17.2112H39.3036L38.655 20.8506ZM53.9524 20.8506H49.4482L49.25 18.8688H45.3404L44.4576 20.8506H39.7192L46.2052 8.23891H51.9345L53.9524 20.8506ZM47.4844 14.0583L46.7817 15.6438H48.9437L48.7996 14.0583C48.7275 13.3917 48.6375 12.3467 48.6014 11.4459H48.5834C48.151 12.4728 47.8267 13.2656 47.4844 14.0583ZM60.5309 21.1569C56.6212 21.1569 54.171 19.3012 54.171 15.7158C54.171 11.0135 56.9455 7.93263 61.9722 7.93263C65.1792 7.93263 67.7555 9.46405 68.278 12.7431L63.7018 13.4998C63.5757 12.1485 63.0352 11.2657 61.738 11.2657C60.8912 11.2657 60.3687 11.4999 59.9183 11.9864C59.2517 12.707 58.8373 14.6889 58.8373 15.932C58.8373 16.4545 58.9454 16.8329 59.1616 17.1392C59.4679 17.5896 60.0084 17.8238 60.729 17.8238C62.0623 17.8238 62.891 17.0671 63.2334 15.6618L67.7736 16.7788C66.6025 19.6074 64.0081 21.1569 60.5309 21.1569ZM77.7865 8.23891H83.2816L77.4982 13.4097L81.2457 20.8506H76.2731L74.2012 16.3644L72.922 17.4995L72.3274 20.8506H68.0214L70.2375 8.23891H74.5435L73.8588 12.0765L77.7865 8.23891Z",
    fill: "url(#paint0_linear_22695_117974)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_22695_117974)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.8078 20.8506H84.3577L86.5737 8.23891H96.7892L96.2127 11.572H90.4293L90.141 13.3016H95.2758L94.6993 16.5626H89.5645L88.8078 20.8506ZM108.079 18.022C107.971 19.0309 107.989 19.9858 108.458 20.7965L108.44 20.8506H103.773C103.377 20.0939 103.485 19.2111 103.593 18.2922C103.737 17.1031 103.359 16.7067 102.17 16.7067H100.999L100.26 20.8506H95.882L98.0981 8.23891H104.638C107.377 8.23891 109.377 9.1938 109.377 11.8062C109.377 13.752 108.35 14.797 106.782 15.3195C107.809 15.7879 108.223 16.7248 108.079 18.022ZM101.521 13.77H102.764C104.026 13.77 104.764 13.4637 104.764 12.2927C104.764 11.3738 104.152 11.2657 103.179 11.2657H101.954L101.521 13.77ZM113.968 20.8506H109.518L111.734 8.23891H116.184L113.968 20.8506ZM121.835 20.8506H115.781L117.997 8.23891H123.42C127.492 8.23891 129.6 10.4009 129.6 13.752C129.6 18.1481 126.663 20.8506 121.835 20.8506ZM121.853 11.6441L120.808 17.5896H121.673C122.736 17.5896 123.546 17.3013 124.051 16.7067C124.664 16.0221 124.916 14.9952 124.916 13.752C124.916 13.1394 124.772 12.653 124.573 12.3287C124.213 11.7702 123.565 11.6441 122.592 11.6441H121.853ZM142.414 20.8506H137.91L137.712 18.8688H133.802L132.92 20.8506H128.181L134.667 8.23891H140.397L142.414 20.8506ZM135.946 14.0583L135.244 15.6438H137.406L137.262 14.0583C137.19 13.3917 137.1 12.3467 137.064 11.4459H137.045C136.613 12.4728 136.289 13.2656 135.946 14.0583ZM148.705 20.8506H144.237L145.083 16.1302L141.84 8.23891H146.615L147.209 10.1667C147.335 10.5811 147.57 11.4639 147.822 12.3647C148.362 11.554 148.831 10.7793 149.263 10.1487L150.56 8.23891H155.569L149.497 16.3104L148.705 20.8506Z",
    fill: "url(#paint1_linear_22695_117974)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_22695_117974",
    x: 9.59498,
    y: 7.93262,
    width: 79.5581,
    height: 24.9673,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.87133
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.93566
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22695_117974"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22695_117974",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_22695_117974",
    x: 78.4866,
    y: 8.23926,
    width: 82.9536,
    height: 24.354,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.87133
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.93566
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_22695_117974"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_22695_117974",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_22695_117974",
    x1: -25.6392,
    y1: 15.2448,
    x2: 59.3845,
    y2: -3.85033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66974,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_22695_117974",
    x1: 84.0256,
    y1: 16.339,
    x2: 206.499,
    y2: 15.2448,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.432292,
    stopColor: "#DCFAD2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackFridayTagSmall);
export default __webpack_public_path__ + "static/media/black-friday-tag-small.79c3dab9bd8bae74633a549c4f164090.svg";
export { ForwardRef as ReactComponent };